import { productApi, TagTypes } from 'Services/ProductManagement/Features/Product/productApi'
import { useDeleteTariffProductMutation } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import { useAppDispatch } from 'Store'
import { RTKCacheTags } from 'Util/constants'

export default function useDeleteTariffProduct() {
  const dispatch = useAppDispatch()
  const [deleteSingleTariffProduct, state] = useDeleteTariffProductMutation()

  const deleteTariffProduct: typeof deleteSingleTariffProduct = (...args) => {
    const result = deleteSingleTariffProduct(...args)
    result.unwrap().then(() => {
      dispatch(
        productApi.util.invalidateTags([
          { type: TagTypes.PRODUCT, id: RTKCacheTags.LIST },
          { type: TagTypes.PRODUCT, id: RTKCacheTags.LIST_ALL }
        ])
      )
    })
    return result
  }

  return [deleteTariffProduct, state] as const
}
